import { Icon } from '@iconify/react';
import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import useReactApexChart from '../../hook/useReactApexChart';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';

const SalesStatisticOne = () => {
    let { chartOptions, chartSeries } = useReactApexChart();
    const { auth } = useAuth();
    const [series, setSeries] = useState(chartSeries);
    const [options, setOptions] = useState(chartOptions);
    const [totalIncome, setTotalIncome] = useState(0);
    const [percentageChange, setPercentageChange] = useState(0);
    const [avgPerDay, setAvgPerDay] = useState(0);
    const [range, setRange] = useState('Yearly');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/payments/sales-chart?range=${range}`);
                if (response.ok) {
                    const data = await response.json();
                    setSeries(data.series);
                    setTotalIncome(data.total);
                    setPercentageChange(data.percentage_change || 0);
                    setAvgPerDay(data.avg_per_day || 0);
                    
                    // Update x-axis categories
                    setOptions(prev => ({
                        ...prev,
                        xaxis: {
                            ...prev.xaxis,
                            categories: data.categories
                        }
                    }));
                }
            } catch (error) {
                console.error('Failed to fetch sales stats:', error);
            }
        };

        fetchData();
    }, [range, auth]);

    const isPositive = percentageChange >= 0;

    return (
        <div className="col-xxl-6 col-xl-12">
            <div className="card h-100">
                <div className="card-body">
                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                        <h6 className="text-lg mb-0">Sales Statistic</h6>
                        <select 
                            className="form-select bg-base form-select-sm w-auto" 
                            value={range}
                            onChange={(e) => setRange(e.target.value)}
                        >
                            <option value="Yearly">Yearly</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                            <option value="Today">Today</option>
                        </select>
                    </div>
                    <div className="d-flex flex-wrap align-items-center gap-2 mt-8">
                        <h6 className="mb-0">AED {totalIncome.toLocaleString()}</h6>
                        <span className={`text-sm fw-semibold rounded-pill ${isPositive ? 'bg-success-focus text-success-main border br-success' : 'bg-danger-focus text-danger-main border br-danger'} px-8 py-4 line-height-1 d-flex align-items-center gap-1`}>
                            {Math.abs(percentageChange)}% <Icon icon={isPositive ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
                        </span>
                        <span className="text-xs fw-medium">+ AED {avgPerDay.toLocaleString()} Per Day</span>
                    </div>
                    <ReactApexChart options={options} series={series} type="area" height={264} />
                </div>
            </div>
        </div>
    );
};

export default SalesStatisticOne;
